export enum EditorModeEnum {
    CHART_TYPE = 'CHART_TYPE',
    CLOSED = 'CLOSED',
    DASHBOARD_TYPE = 'DASHBOARD_TYPE',
    NEW_STAGE = 'NEW_STAGE',
    SELECT_DASHBOARD = 'SELECT_DASHBOARD',
    SETTINGS = 'SETTINGS',
    STAGE = 'STAGE',
    STAGE_GROUP = 'STAGE_GROUP',
    WIDGET = 'WIDGET',
}
